<script>
  import Router, { replace } from "svelte-spa-router";
  import LayoutSidebar from "../../layouts/LayoutSidebar.svelte";
  import List from "./List.svelte";
  import Add from "./Add.svelte";
  import Detail from "./Detail.svelte";
  import Edit from "./Edit.svelte";
  import MemberRemoval from "./MemberRemoval.svelte";
  import MemberRequest from "./MemberRequest.svelte";
  import { onMount } from "svelte";
  import { checkRoleModule } from "../../utils/utils";
  import { roleModules } from "../../stores/store";
  import { CELLGROUP_MODULE } from "../../utils/const";

  const prefix = "/cellgroup";
  const routes = {
    "/": List,
    "/add": Add,
    "/:_id/Edit": Edit,
    "/:_id/detail": Detail,
    "/:_id/member/removal": MemberRemoval,
    "/:_id/member/request": MemberRequest,
  };

  onMount(() => {
    if (!checkRoleModule($roleModules, CELLGROUP_MODULE)) {
      replace("/");
    }
  });

  let openSidebar = false;
</script>

<LayoutSidebar bind:openSidebar>
  <div class="md:flex pt-14 mt-8 md:mt-4">
    <!-- // content -->
    <div class="w-full md:ml-64">
      <Router {routes} {prefix} />
    </div>
  </div>
</LayoutSidebar>
